export default __webpack_public_path__ + "static/media/gift-green.f857f86e.svg";